<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper tribeSelection" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="tribeSelection" ng-controller="tribeSelectionCtrl">
				<div class="selectionHeaderContainer">
					<div class="trapezoidalOrnament onTop"></div>
					<div class="selectionHeader">
						<div class="fromEnding"></div>
						<div class="content" translate=""><span>Выбери свой путь</span></div>
						<div class="toEnding"></div>
					</div>
				</div>
				<div class="closeOverlay clickable" clickable="backToLobby()" @click="onBackToLobby()" :class="{'hover': cancelHover}" @mouseover="cancelHover = true" @mouseleave="cancelHover = false">
					<i :class="{'action_cancel_small_flat_black': !cancelHover, 'action_cancel_small_flat_green': cancelHover}"></i>
				</div>
				<div class="tribeCarouselContainer">
					<div class="tribeSpotlight"></div>
					<div class="carouselArrow fromArrow clickable" clickable="moveCarousel(config['direction'] == 'rtl')" @click="onCarouselPrev()"></div>
					<div class="carouselArrow toArrow clickable" clickable="moveCarousel(config['direction'] != 'rtl')" @click="onCarouselNext()"></div>
					<div class="tribeCarousel" :class="{'moveDirectionFrom': moveDirection == 'from', 'moveDirectionTo': moveDirection == 'to'}">
						<div v-for="(tribe, index) in tribes" :key="tribe.id" class="carouselItem" :class="[tribe.type, 'position'+tribe.pos]" @click="tribe.pos == 1 ? onCarouselPrev() : (tribe.pos == 2 ? onCarouselNext() : '')" clickable="selectedTribeId != n ? moveCarousel(selectedTribeId - n + (selectedTribeId - n < 0 ? 3 : 0) > 1) : ''">
							<i class="tribeImage" :class="[tribe.type, {'selectAnimation': tribe.selectAnimation}]"></i>
							<div class="hoverLighting"></div>
						</div>
					</div>
				</div>
				<div class="tribeSelectionContainer tkDialogue">
					<div class="trapezoidalOrnament onTop"></div>
					<div class="selectionContainer dialogueContent tribeInfo">
						<div class="infoHeader">
							<span>{{selTribe.name}}</span>
						</div>
						<div class="infoIconContainer" :content="selTribe.tooltip" v-tippy="{placement: 'top'}" tooltip-url="tpl/tribeSelection/partials/infoTooltip.html" tooltip-placement="above">
							<i class="symbol_i_medium_flat_white"></i>
						</div>
						<hr>
						<ul>
							<li v-for="option in selTribe.options">
								<i class="star"></i>
								<span>{{option}}</span>
							</li>
						</ul>
					</div>
					<div class="selectionContainer dialogueContent tribeAction">
						<button class="selectButton clickable" clickable="selectTribe()" @click="onModalClose(close)">
							<div class="content">
								<span ng-transclude="" class="innerText">
									<span>Выбрать племя</span>
								</span>
								<!-- ngIf: price > 0 || forceGoldUsage -->
								<!-- ngIf: price == -1 && !forceGoldUsage -->
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
						<div class="options">
							<div class="serverOption">
								<span translate=""><span>Игровой мир:</span></span>:
								<span class="serverName">RU2X3</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
		
		tribes: [
			{
				id: 1,
				pos: 2,
				name: 'Римляне',
                type: 'roman',
                tooltip:  `<div class="selectTribeTooltip tribe1">
	<div class="category" translate=""><span>Торговцы</span></div>
	<ul options="1" translate=""><ul class="uList"><li>Скорость: средняя</li> <li>Вместимость: средняя</li></ul></ul>
	<div class="category" translate=""><span>Войска</span></div>
	<ul options="1" translate=""><ul class="uList"><li>Дорогое обучение</li> <li>Дешевое содержание</li> <li>Долгое время обучения</li></ul></ul>
	<div class="category" translate=""><span>Здания</span></div>
	<ul options="1" translate=""><ul class="uList"><li>Водопой: Сокращает затраты на содержание кавалерии</li> <li>Торговая палата: Большой бонус для торговцев</li></ul></ul>
</div>`,
				options: [
					'Для опытных стратегов',
					'Очень сильные войска',
					'Долгое дорогое обучение',
				],
				selectAnimation: false,
			},
			{
				id: 2,
				pos: 1,
				name: 'Германцы',
                type: 'teuton',
                tooltip:  `<div class="selectTribeTooltip tribe2">
	<div class="category" translate=""><span>Торговцы</span></div>
	<ul options="2" translate=""><ul class="uList"><li>Скорость: низкая</li> <li>Вместимость: высокая</li></ul></ul>
	<div class="category" translate=""><span>Войска</span></div>
	<ul options="2" translate=""><ul class="uList"><li>Дешевое обучение</li> <li>Дорогое содержание</li> <li>Короткое время обучения</li></ul></ul>
	<div class="category" translate=""><span>Здания</span></div>
	<ul options="2" translate=""><ul class="uList"><li>Пивоварня: Бонус к силе атаки</li> <li>Земляной вал: Почти невозможно разрушить</li></ul></ul>
</div>`,
				options: [
					'Для активных воинственных игроков',
					'Очень сильная атака',
					'Дешевая пехота',
				],
				selectAnimation: false,
			},
			{
				id: 3,
				pos: 0,
				name: 'Галлы',
                type: 'gaul',
                tooltip:  `<div class="selectTribeTooltip tribe3">
	<div class="category" translate=""><span>Торговцы</span></div>
	<ul options="3" translate=""><ul class="uList"><li>Скорость: высокая</li> <li>Вместимость: средняя</li></ul></ul>
	<div class="category" translate=""><span>Войска</span></div>
	<ul options="3" translate=""><ul class="uList"><li>Очень быстрые</li> <li>Средняя цена</li> <li>Среднее время обучения</li></ul></ul>
	<div class="category" translate=""><span>Здания</span></div>
	<ul options="3" translate=""><ul class="uList"><li>Капканщик: Ловит войска противника в ловушки</li> <li>Тайник: Хранит в два раза больше ресурсов</li></ul></ul>
</div>`,
				options: [
					'Подходят новичкам',
					'Очень сильны в защите',
					'Быстрая эффективная кавалерия',
				],
				selectAnimation: false,
			},
		],
		selectedTribeId: 3,
		
		moveDirection: 'to',
	}),
	computed: {
		selTribe(){
			return this.tribes.find(t => t.id == this.selectedTribeId);
		},
	},
	methods: {
		range: lib.range,
		
		onBackToLobby(){
			location.href = 'https://iwpanel.g.bsrv.su';
		},
		onCarouselPrev(){
			this.moveDirection = 'from';
			this.tribes.map(el => {
				if(el.pos > 0){
					el.pos--;
				} else {
					el.pos = this.tribes.length - 1;
				}
				return el;
			});
			let index = this.tribes.findIndex(t => t.id == this.selectedTribeId);
			if(index > 0){
				this.selectedTribeId = this.tribes[index - 1].id;
            } else {
				this.selectedTribeId = this.tribes[this.tribes.length - 1].id;
			}
			let selTribe = this.tribes.find(t => t.id == this.selectedTribeId);
			selTribe.selectAnimation = true;
			setTimeout(() => {
				selTribe.selectAnimation = false;
			}, 1000);
		},
		onCarouselNext(){
			this.moveDirection = 'to';
			this.tribes.map(el => {
				if(el.pos < this.tribes.length - 1){
					el.pos++;
				} else {
					el.pos = 0;
				}
				return el;
			});
			let index = this.tribes.findIndex(t => t.id == this.selectedTribeId);
			if(index < this.tribes.length - 1){
				this.selectedTribeId = this.tribes[index + 1].id;
            } else {
				this.selectedTribeId = this.tribes[0].id;
			}
			let selTribe = this.tribes.find(t => t.id == this.selectedTribeId);
			selTribe.selectAnimation = true;
			setTimeout(() => {
				selTribe.selectAnimation = false;
			}, 1000);
		},
		
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>